import { useState } from "react";

export function useToggle(initialState) {
  const [isToggled, setIsToggled] = useState(initialState);

  const toggle = () => setIsToggled(!isToggled);

  return [isToggled, toggle];
}
